/*
 * @Author: Gary
 * @Date: 2017-09-05 10:27:19
 * @Last Modified by: Gary
 * @Last Modified time: 2018-04-09 16:48:35
 * 配置全局组件
 */
// import Vue from 'vue'
// import UploadImage from './upload'
// import UploadFile from './uploadFile'
// import Tinymce from './tinymce'
// import confirmModal from '@/components/confirm'
// import cancelModal from '@/components/confirm/cancel.js'
import Pagination from '@/components/pagination'
// import TreeEdit from '@/components/TreeEdit'


export default {
  install: Vue => {
    // Vue.component(UploadFile.name, UploadFile)
    // Vue.component(UploadImage.name, UploadImage);
    // Vue.component(Tinymce.name, Tinymce);
    Vue.component(Pagination.name, Pagination);
    // Vue.component(TreeEdit.name, TreeEdit);
    // Vue.prototype.confirmModal = confirmModal;
    // Vue.prototype.cancelModal = cancelModal;
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js